/**
 * Toggle a body class on pointer-lock change so CSS can disable
 * React-overlay hit-testing while the user is looking around.
 *
 * Real beacon data showed pointerover/mouseover events spiking to 128 ms
 * — React's event delegation walking the overlay tree on every pointer
 * move. With pointer-locked, no UI element should care about pointer
 * position. CSS in `styles.css` reads `body.pointer-locked` to set
 * pointer-events: none on #react-root and #ui-root for that window.
 *
 * Side-effect file — imported from src/index.ts.
 */

if (typeof window !== 'undefined') {
  const sync = () => {
    const locked = !!document.pointerLockElement
    document.body.classList.toggle('pointer-locked', locked)
  }
  document.addEventListener('pointerlockchange', sync)
  // Initial state — in case lock happened before module loaded.
  sync()
}
